export class FileEvent {
  constructor(documentId: number, type?: string) {
    this.documentId = documentId;
    this.type = type;
  }
  documentId: number;
  type: string;
}
